import { db } from '../firebase/config';
import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  updateDoc,
  getDoc,
  onSnapshot,
  setDoc,
} from 'firebase/firestore';
import { useEffect, useReducer, useState } from 'react';

const initialState = {
  document: null,
  isPending: false,
  error: null,
  success: null,
};

const firesstoreReducer = (state, action) => {
  switch (action.type) {
    case 'IS_PENDING':
      return { ...state, isPending: true, success: false, error: null };
    case 'ADD_DOC':
      return {
        document: action.payload,
        isPending: false,
        error: null,
        success: true,
      };
    case 'UPDATED_DOC':
      return {
        document: action.payload,
        isPending: false,
        error: null,
        success: true,
      };
    case 'ERROR':
      return {
        document: null,
        isPending: false,
        error: action.payload,
        success: false,
      };
    case 'REMOVE_DOC':
      return {
        document: null,
        isPending: false,
        error: action.payload,
        success: true,
      };
    default:
      return state;
  }
};

export const useFireStore = (collectionDoc, docCollection) => {
  const [response, dispatch] = useReducer(firesstoreReducer, initialState);
  const [isCancelled, setIsCancelled] = useState(false);

  const ref = collection(db, collectionDoc);

  const dispatchIfNotCancelled = (action) => {
    if (!isCancelled) {
      dispatch(action);
    }
  };

  const addDocument = async (doc) => {
    dispatch({ type: 'IS_PENDING' });
    try {
      const addedDocument = await addDoc(ref, doc);

      dispatchIfNotCancelled({
        type: 'ADD_DOC',
        payload: addedDocument.id,
      });
    } catch (err) {
      dispatchIfNotCancelled({ type: 'ERROR', payload: err.message });
    }
  };

  const updateDocument = async (id, updatedFields) => {
    const docRef = doc(db, collectionDoc, id);

    dispatch({ type: 'IS_PENDING' });
    try {
      await updateDoc(docRef, updatedFields);
      dispatchIfNotCancelled({ type: 'UPDATED_DOC', payload: updatedFields });
    } catch (err) {
      dispatchIfNotCancelled({ type: 'ERROR', payload: err.message });
    }
  };

  const addComment = async (id, userId, updatedFields, updatedUser) => {
    const docRef = doc(db, collectionDoc, id);
    const userRef = doc(db, docCollection, userId);

    dispatch({ type: 'IS_PENDING' });
    try {
      await Promise.all([
        updateDoc(docRef, updatedFields),
        updateDoc(userRef, updatedUser),
      ]);
      dispatchIfNotCancelled({ type: 'UPDATED_DOC', payload: updatedFields });
    } catch (err) {
      dispatchIfNotCancelled({ type: 'ERROR', payload: err.message });
    }
  };

  const deleteDocument = async (id) => {
    const docRef = doc(db, collectionDoc, id);

    dispatch({ type: 'IS_PENDING' });
    try {
      const removeDocument = await deleteDoc(docRef);
      dispatchIfNotCancelled({ type: 'REMOVE_DOC', payload: removeDocument });
    } catch (err) {
      dispatchIfNotCancelled({ type: 'ERROR', payload: err.message });
    }
  };

  useEffect(() => {
    setIsCancelled(false);
    return () => setIsCancelled(true);
  }, []);

  return {
    response,
    addDocument,
    deleteDocument,
    updateDocument,
    addComment,
  };
};
